import { get } from '..';
import routes from './routes';

const UserServices = {
  getUserProfile: async () => {
    const data = await get(routes.getUserProfile);
    return data;
  },
  getUsers: async (params) => {
    const data = await get(routes.getUsers, params);
    return data;
  }
}

export default UserServices